import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux';

import {
  Route,
  Switch
} from 'react-router-dom';

import App from './App'
import MarketDetail from '../components/Desktop/MarketDetail';
import MarketDetailMobile  from '../components/Mobile/MarketDetailMobile';
import MarketCompareSelection  from '../components/Mobile/MarketCompareSelection';
import MarketComparisonMobile from '../components/Mobile/MarketComparisonMobile';
import { setBasePath } from '../actions';
import ScrollToTopRoute from './ScrollToTopRoute';


class Root extends React.Component{

// IMPORTANT: Please add the route path in this method also whenever we add a new Route
 extractBasePath = () => 
{
   let knownPaths = ['/marketdetail', '/marketdetailmobile', '/marketcompareselection', '/marketcomparisonmobile'];
   
   let locationpath  = window.location.pathname;

   for (let i = 0; i < knownPaths.length; i++) {
    let match = knownPaths[i];
    if (locationpath.indexOf(match) !== -1) {
     //match found   
     return locationpath === '/' ? "" : locationpath.substring(0, locationpath.indexOf(match));
    }
  }
  return locationpath === '/' ? "" : locationpath;

}

componentDidMount()
{
   let basepath = this.extractBasePath();
   
   this.props.setBasePath( basepath);

   // This is meant to be hit only on home page refresh on dotcom page
   if(this.props.persistedState)
   {
      if (performance.navigation.type === 1 && window.location.pathname === basepath)
      {
          sessionStorage.clear();
          window.location.reload(basepath);
      }
   }
}


  render()
  {
    let basepath = this.extractBasePath().toString();

    return(
  <div>
    <Switch>
         <Route exact path= {basepath ==="" ?   "/" : (basepath)} component={App} />
         <Route path={basepath + "/marketdetail"} component={MarketDetail} />
         <Route path={basepath + "/marketdetailmobile"} component={MarketDetailMobile} />
         <ScrollToTopRoute path={basepath + "/marketcompareselection"} component={MarketCompareSelection} />
         <Route path={basepath + "/marketcomparisonmobile"} component={MarketComparisonMobile}/>
    </Switch>
  </div>
    )
  }
  

}


Root.propTypes = {
  store: PropTypes.object.isRequired,
}


const mapDispatchToProps = (dispatch) => {
  return {
    setBasePath: (basepath) => {
      dispatch(setBasePath(basepath))
    }
  }
}

const mapStateToProps = (state) => {

  return {
   basepath : state.basepath
  };
};

export default  connect( mapStateToProps , mapDispatchToProps)(Root);

